
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system-design",
      function () {
        return require("private-next-pages/system-design.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system-design"])
      });
    }
  